
export function toNum(value: unknown): number | undefined {

    if (null === value || undefined === value) return undefined
    const parsed = parseInt(String(value), 10)

    if (isNaN(parsed)) return undefined
    return parsed
}